import React from "react";
import PropTypes from "prop-types";
import Box from "@amzn/meridian/box";
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import Icon from "@amzn/meridian/icon";
import Link from "@amzn/meridian/link";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";

function formatValue(val) {
  if (val === null || val === undefined || val === "NOT_AVAILABLE") {
    return "N/A";
  }
  if (typeof val === "number") {
    return Math.round(val);
  }
  if (typeof val === "object" && val !== null && val.hasOwnProperty("value")) {
    return Math.round(val.value);
  }
  return val.toString();
}

const MetricBox = function (props) {
  const { name, description, subMetrics, inAlert, onMetricClick } = props;

  // Callback for metric click
  function handleMetricClick(metricName) {
    if (typeof onMetricClick === "function") {
      onMetricClick(metricName);
    }
  }

  return (
    <Box type="outline" spacingInset="400">
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Heading
          level={3}
          type="h300"
          alignment="left"
          style={{ display: "flex", alignItems: "center" }}
        >
          {name}
          {description && (
            <Tooltip position="right" title={description}>
              <Icon
                className="custom-tool-tip"
                tokens={infoKnockoutTokens}
                style={{ marginLeft: 8, cursor: "pointer", color: "#888" }}
              />
            </Tooltip>
          )}
          {inAlert && (
            <Icon
              className="custom-tool-tip"
              tokens={alertTokens}
              style={{ marginLeft: 8, color: "#E47911" }}
              aria-label="Alert"
            />
          )}
        </Heading>
      </div>
      <Row width="100%" widths={["grid-6", "grid-6"]}>
        {subMetrics.map(function (metric, idx) {
          return (
            <div key={idx}>
              <Text type="b100">{metric.name}</Text>
              <Text type="d50" color={metric.inAlert ? "critical" : undefined}>
                <Link
                  type="secondary"
                  onClick={() => handleMetricClick(metric.name)}
                >
                  {formatValue(metric.value)}
                </Link>
              </Text>
            </div>
          );
        })}
      </Row>
    </Box>
  );
};

MetricBox.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  inAlert: PropTypes.bool,
  subMetrics: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.object,
      ]),
      inAlert: PropTypes.bool,
    }),
  ).isRequired,
  onMetricClick: PropTypes.func, // callback for metric click
};

export default MetricBox;



// WEBPACK FOOTER //
// ./src/components/quality/common/MetricBox.js